








































import {Component, Mixins} from "vue-property-decorator";
import NumberGenerator from "@/common/mixins/numberGenerator";
import OrderComponent from "@/components/order/orderComponent.vue";
import QDetailModal from "@/components/qDetailModal.vue";
import Table from "@/model/table";
import History from "@/model/history";
import moment from "moment/moment";
import historyApi from "@/api/historyApi";
import itemApi from "@/api/itemApi";
import Menu from "@/model/menu";
import {namespace} from "vuex-class";

const menuStore = namespace("MenuStore")

@Component({
  name: "historyOrder",
  components: {OrderComponent, QDetailModal},
})

export default class HistoryOrder extends Mixins(NumberGenerator) {
  @menuStore.Getter
  getMenuList!: Menu[];

  public historyList: History[] = null;
  public table = new Table();
  public elapsedMinute: number;
  public totalPrice =  0;
  public totalQuantity = 0;

  async mounted() {
    this.historyList = await historyApi.index()
    this.getTotalQuantity()
    this.getTotalPrice()
    this.elapsedMinute = this.table.getElapsedMinute()
  }

  public async openMenuDetail(menu) {
    const menuDetail = await itemApi.getMenuByIdentifier(menu.identifier)
    if (menuDetail) {
      this.detailModal(menuDetail, false);
    }
  }

  public detailModal(menu, isEdit) {
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }

  public timeFormat(time) {
    return moment(time).format('H:mm');
  }

  private async getTotalQuantity() {
    this.historyList.map(value => {
      this.totalQuantity += value.quantity
    });
  }

  private async getTotalPrice() {
    this.historyList.map(value => {
      this.totalPrice += value.rowTotalPrice
    });
  }

  getImageFileName(identifyHistory) {
    let imageFileName = 'https://image-provider.demo.hayawaza.aws.qumu.co.jp/image/no_image.jpg';
    this.getMenuList.filter(menu => {
      if (menu.identifier === identifyHistory && menu.imageFileName !== "") {
        imageFileName = menu.imageFileName
      }
    })

    return imageFileName
  }
}
